module.exports = __webpack_public_path__ + "static/media/IMG-3.3ec6d3da.jpg";